import script from "./FeedbackFormHeaderButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackFormHeaderButton.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackFormHeaderButton.vue?vue&type=style&index=0&id=20de0800&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20de0800"]])

export default __exports__